import React from "react";
import "./Frame7.css";

function Frame7(props) {
  const { className } = props;

  return (
    <div className={`frame-7-9 ${className || ""}`}>
      <div className="place-268 valign-text-middle inter-bold-tropical-rain-forest-18px">Back</div>
    </div>
  );
}

export default Frame7;
